import {
  evaluateParametrized,
  isNum,
  isNumArr
} from '~/models/pulser-schema/exprEval';
import { isParam } from '~/models/pulser-schema/validation';
import { assert } from '~/util';
import type {
  Expression,
  VariableRef,
  Variables
} from '~/models/pulser-schema';
import type { EvaluatedExpr } from '~/models/pulser-schema/exprEval';

type Parametrized = VariableRef | Expression;

/** Evaluate any parametrized expression */
function assertEval(param: Parametrized, vars: Variables): EvaluatedExpr {
  return evaluateParametrized(param, vars).unwrap();
}

/** Evaluate numeric (float) parameter using passed variable values */
export function evaluateNum(
  param: number | Parametrized,
  vars: Variables
): number {
  if (!isParam(param)) {
    return param;
  }
  const val = assertEval(param, vars);
  assert(!val.array && isNum(val.value));
  return val.value;
}

/** Evaluate integer parameter using passed variable values */
export function evaluateInt(
  param: number | Parametrized,
  vars: Variables
): number {
  return Math.floor(evaluateNum(param, vars));
}

/** Evaluate numeric-array parameter using passed variable values */
export function evaluateNumArray(
  param: number[] | Parametrized,
  vars: Variables
): number[] {
  if (!isParam(param)) {
    return param;
  }
  const val = assertEval(param, vars);
  assert(val.array && isNumArr(val.value));
  return val.value;
}
